import { render, staticRenderFns } from "./freeAndCertification.vue?vue&type=template&id=1c0e5b9c&scoped=true&"
import script from "./freeAndCertification.vue?vue&type=script&lang=js&"
export * from "./freeAndCertification.vue?vue&type=script&lang=js&"
import style0 from "./freeAndCertification.vue?vue&type=style&index=0&id=1c0e5b9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0e5b9c",
  null
  
)

export default component.exports